import React from 'react';
import { useNavigate } from 'react-router-dom';
import './home.css';

// The persistent "Lord Crawford" title. It lives in the Layout (not in any
// page) so it stays mounted across route changes and CSS-transitions its size
// between the large home state and the small subpage state. Clicking it (on a
// subpage) returns home.
const Title = ({ isHome }) => {
    const navigate = useNavigate();

    // Always the same element (an <h1>) across every route — its font-size/
    // top CSS-transition on home <-> subpage nav depends on the DOM node
    // persisting; swapping tag names here would remount it and turn that
    // transition into a hard cut. Case-study pages demote their own project
    // title to <h2> so this stays the page's one <h1>.
    return (
        <h1
            id="name"
            onClick={() => { if (!isHome) navigate('/'); }}
            style={{ cursor: isHome ? 'default' : 'pointer' }}
        >
            <div>Lord</div>
            <div>Crawford</div>
        </h1>
    );
};

export default Title;
